// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id',
    requestBody: null,
    response: '{"success":true,"data":"ImportListino"}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id/righe?page=1&limit=50&search=&tipologia=&collezione=&categoriaMerceologica=&categoriaConfigurazione=&effetto=',
    requestBody: null,
    response: '{"success":true,"data":"ListinoFornitore[]","total":"number","page":"number","limit":"number"}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/listini/:id/importa',
    requestBody: '{"tutti":"boolean","righeIds?":"number[]"}',
    response: '{"success":true,"data":{"elaborate":"number","create":"number","aggiornate":"number","errori":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/listini/:id/importa',
    requestBody: '{"tutti":"boolean","righeIds?":"number[]"}',
    response: '{"success":true,"data":{"elaborate":"number","create":"number","aggiornate":"number","errori":"number"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id/pre-valida',
    requestBody: null,
    response: '{"success":true,"data":{"totale":"number","validi":"number","errori":"number","avvisi":"number","righe":"PrevalidaRiga[]"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
